// extracted by mini-css-extract-plugin
export default {"root":"JsonViewer_root__pnP9R","copyBtn":"JsonViewer_copyBtn__uwQV1","copyStatus":"JsonViewer_copyStatus__BYyyA"};